<template lang="pug">
  v-layout(row wrap)
    v-flex.header-acct(xs12)
      title-section(text="Contacts")
        template(slot='icon')
          v-icon.mr-2(color="black") group
    v-flex(xs12)
      title-section(text="Import / Export", type="subtitle", hash="import-export")
    v-flex(xs12)
      v-layout(row)
        v-flex(xs2)
          v-btn(
            color="primary"
          )
            v-icon(
              medium
            ) exit_to_app
            span Import Contacts
        v-flex.ml-5(xs2)
          v-btn(
            color="primary"
          )
            v-icon(
              medium
              color="white"
            ) $vuetify.icons.export
            span Export Contacts
    v-flex(xs12)
      v-layout(row)
        v-flex(xs3 offset-xs2)
          .text-xs-center.primary--text
            v-icon(
              small
              color="primary"
            ) schedule
            span View Export History
    v-flex(xs12)
      title-section(text="Duplicates", type="subtitle" hash="duplicates")
    v-flex.ml-3(xs12)
      v-tabs(slider-color="primary")
        v-tab()
          span Duplicates
        v-tab()
          span By Contact
        v-tab()
          span Selected        
        v-tab-item
          v-layout(row)
            v-flex(xs12)
              p.ml-1 To get started, select the type of duplicate contacts you want to search for.
          v-layout(row)            
            v-flex(xs12)
              v-expansion-panel(
                v-model="duplicates"
                expand
              )
                v-expansion-panel-content
                  div(slot="header") Exact Match
                  v-card
                    p content Exact Match
                v-expansion-panel-content
                  div(slot="header") Name
                  v-card.xs12
                    v-card-title
                      table.table-duplicates
                        thead
                          tr
                            td
                             p.ml-3.mt-2 Merge 2 Contacts
                        tbody
                          tr
                            td
                              .info-contact.master
                                p.primary--text Julian Lambert (Master)
                                p ID: 129389600 / Email: (No Email) / Mobile (No Mobile) / Home: (No Home Phone)
                              .info-contact
                                p.primary--text Julian Lambert
                                p ID: 129389600 / Email: (No Email) / Mobile (No Mobile) / Home: (No Home Phone)
                v-expansion-panel-content
                  div(slot="header") Email
                v-expansion-panel-content
                  div(slot="header") Mobile Phone
                v-expansion-panel-content
                  div(slot="header") Home Phone
        v-tab-item
          v-layout(row)
            v-flex
              p By Contact Content
        v-tab-item
          v-layout(row)
            v-flex
              p Selected Content

    v-flex.mt-3(xs12)
      title-section(v-if="permissionsLoaded" :text="customFieldsTitle", type="subtitle" :hash="customFieldsHash")
    v-flex.ml-3(v-if="permissionsLoaded" xs12)
      custom-fields

    v-flex.mt-3(xs12)
      title-section(v-if="permissionsLoaded" :text="hotnessTitle", type="subtitle" :hash="hotnessHash")
    v-flex.ml-3(v-if="permissionsLoaded" xs12)
      hotness

    v-flex.mt-3(xs12)
      title-section(v-if="permissionsLoaded" :text="contactTagsTitle", type="subtitle" :hash="contactTagsHash")
    v-flex.ml-3(v-if="permissionsLoaded" xs12)
      contact-tags

    v-flex.mt-3(xs12)
      title-section(v-if="permissionsLoaded" :text="relationshipTypeTitle" type="subtitle" :hash="relationshipTypeHash")
    v-flex.mt-3(v-if="permissionsLoaded" xs12)
      contact-types
    v-flex.mt-3(xs12)
      title-section(text="POC" type="subtitle" hash="poc")
    v-flex.mt-3(xs12)
      span This is a POC on how to implement ResourceTable component and editable fields components
      POC
</template>
<script>
import { mapActions } from 'vuex';
import TitleSection from './TitleSection';
import POC from './POC';
import ContactTags from './ContactTags';
import ContactTypes from './ContactTypes';
import CustomFields from './CustomFields';
import Hotness from './Hotness';
import { CONTACTS } from '../config';

export default {
  name: 'Contacts',
  components: {
    TitleSection,
    Hotness,
    POC,
    ContactTags,
    ContactTypes,
    CustomFields,
  },
  data() {
    return {
      contacts: CONTACTS,
      customFieldsTitle: CONTACTS.customFields.title,
      customFieldsHash: CONTACTS.customFields.hash,
      contactTagsTitle: CONTACTS.tags.title,
      contactTagsHash: CONTACTS.tags.hash,
      hotnessTitle: CONTACTS.hotness.title,
      hotnessHash: CONTACTS.hotness.hash,
      relationshipTypeTitle: CONTACTS.relationshipTypes.title,
      relationshipTypeHash: CONTACTS.relationshipTypes.hash,
      permissionsLoaded: false,
      duplicates: [false, true, false, false]
    }
  },
  methods: {
    ...mapActions('subAccountPermissions', [
      'findPermissions'
    ]),
  },
  async mounted() {
    await this.findPermissions();
    this.permissionsLoaded = true;
  }
}
</script>
<style lang="scss" scoped>
.count-rows {
  color: rgba(0, 0, 0, 0.54);
  font-size: 18px;
  font-style: normal;
  margin-top: 18px;
  padding-left: 10px;
  font-weight: 500;
}

.table-duplicates {
  width: 100%;
  border: 1px solid #979797;
  border-collapse: collapse;
  border-spacing: 0px;

  thead tr {
    height: 40px;
    width: 100%;
    background-color: #f6f6f6;
    padding: 20px;
    border: 1px solid #979797;
  }

  .info-contact {
    padding: 12px;
    background-color: #fafafa;
    margin: 10px;
    border-radius: 10px;
    height: 60px;

    p {
      line-height: 10px;
    }
  }

  .master {
    background-color: #e9eff5;
  }
}

.v-btn {
  color: var(--v-secondary-lighten3);
}
</style>
